import { render, staticRenderFns } from "./TenderAgreementResult.vue?vue&type=template&id=20053417"
import script from "./TenderAgreementResult.vue?vue&type=script&lang=js"
export * from "./TenderAgreementResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports